import { css } from '@emotion/react'
import { Button, Cell, DropdownItem, Grid, HFlow, Icon, Tooltip } from 'bold-ui'
import { FieldStatusEnum, ListFieldStatus } from 'components/form'
import { TextStatus } from 'components/text/TextStatus'
import { Fragment } from 'react'
import { getEditableItemRemoveTooltipText } from 'view/atendimentos/atendimento-individual/atendimento-observacao/util-atendObservacao'
import { EditableRow } from 'view/atendimentos/detail/components/EditableList'
import { removeWithOptionalConfirm } from 'view/retificacao-atendimento/removeWithOptionalConfirm'

import { NotificacaoCasoSuspeitoFieldModel } from './NotificacaoCasoSuspeitoField'

interface NotificacaoRowProps {
  model: NotificacaoCasoSuspeitoFieldModel
  onRemove(itemToRemove: NotificacaoCasoSuspeitoFieldModel): void
  onPrint(itemToPrint: NotificacaoCasoSuspeitoFieldModel): void
  onReset?: (itemToReset: NotificacaoCasoSuspeitoFieldModel) => void
  status?: FieldStatusEnum
  controlModifiedStatus?: boolean
}

export function NotificacaoRow(props: NotificacaoRowProps) {
  const { model, onRemove, onPrint, onReset, status, controlModifiedStatus } = props

  const { isEditable, tooltipText } = getEditableItemRemoveTooltipText(model)

  const handleRemove = () =>
    removeWithOptionalConfirm({
      shouldAskConfirmation: controlModifiedStatus,
      title: 'Deseja excluir o campo Ficha de notificação de caso suspeito?',
      icon: { name: 'exclamationTriangleOutline', fill: 'alert' },
      onRemove: () => onRemove(model),
    })

  const handleImprimir = () => onPrint(model)
  const handleReset = () => onReset?.(model)

  return (
    <EditableRow editing={false}>
      <Grid style={styles.grid}>
        <Cell size={9} alignSelf='center'>
          <TextStatus status={status}>{`${model.fichaNotificacao.nomeNotificacao}`}</TextStatus>
        </Cell>
        <Cell size={3} style={styles.actions}>
          {controlModifiedStatus ? (
            <ListFieldStatus status={status} onReset={handleReset} onRemove={handleRemove}>
              <DropdownItem onClick={handleImprimir}>
                <HFlow alignItems='center' hSpacing={0.5}>
                  Imprimir
                </HFlow>
              </DropdownItem>
            </ListFieldStatus>
          ) : (
            <Fragment>
              <Tooltip text='Imprimir'>
                <Button size='small' skin='ghost' onClick={handleImprimir}>
                  <Icon icon='printerOutline' />
                </Button>
              </Tooltip>
              <Tooltip text={tooltipText}>
                <Button size='small' skin='ghost' onClick={handleRemove} disabled={isEditable}>
                  <Icon icon='trashOutline' />
                </Button>
              </Tooltip>
            </Fragment>
          )}
        </Cell>
      </Grid>
    </EditableRow>
  )
}

const styles = {
  grid: css`
    margin: 0;
  `,
  actions: css`
    align-self: center;
    padding: 0.25rem 0;
    text-align: right;
  `,
}
